import favicon from '../../Images/favicon.ico';
import './Loader.css';

const Loader = () => {
  return (
    <div id='pre-load'>
      <div id='loader-main' className='loader-main'>
        <div className='loader-container'>
          <div className='loader-icon'>
            <img src={favicon} alt='icons' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
